import resourceService from './resource_service';

const modelName = 'manifold';

const attributes = {
  name: '',
  color: '',
};

const relationships = {
  allocationUnit: {
    jsonApi: 'hasOne',
  },
  pumps: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships);
